module.exports = __webpack_public_path__ + "img/notwell.db84ce1d.png";